export default __webpack_public_path__ + "static/media/actor.18d7e82c.svg";